import React from 'react';
import uid from 'uid2';
import {
  Tooltip as BPTooltip,
  TooltipProps as ITooltipProps
} from '@blueprintjs/core';
import PortalContainerRef from '../../atoms/portal-container';

import './tooltip.scss';

interface TooltipProps extends ITooltipProps {
  id?: string;
}

/**
 * Extends Blueprint Tooltip
 * https://blueprintjs.com/docs/#core/components/tooltip
 *
 * WAI-ARIA guidelines for tooltip:
 * https://www.w3.org/TR/wai-aria-practices/#tooltip
 *
 * Tooltip container element has role="tooltip"
 * Trigger element has aria-describedby={id}
 *
 * Known issue: Since the React Tooltip doesn't
 * get added to the DOM until the target is hovered over
 * We get an incomplete ARIA attribute warning of
 * "ARIA attribute element ID does not exist on the page"
 */
const Tooltip: React.FC<TooltipProps> = ({
  id,
  content,
  children,
  ...props
}) => {
  id = id || uid(8);
  return (
    <BPTooltip
      {...props}
      portalContainer={PortalContainerRef.current}
      canEscapeKeyClose
      content={
        <div id={id} className="text-center pa-1" role="tooltip">
          {content}
        </div>
      }
    >
      <span aria-describedby={id}>{children}</span>
    </BPTooltip>
  );
};

export default Tooltip;
